import React from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
const L2Sublayout = (props) => (
  <>
    <Placeholder name="rotary-fullwidthsublayout" rendering={props.rendering} />
  </>
);
export default withSitecoreContext()(L2Sublayout);